export function TypingIndicator() {
  return (
    <div className="flex items-start gap-2 px-4 py-2" role="status" aria-label="Tidy is typing">
      <div className="bg-surface rounded-3xl rounded-tl-md px-4 py-3 flex items-center gap-1">
        <span className="w-2 h-2 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 rounded-full bg-muted-foreground animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
}
